import PropTypes from 'prop-types'
import {Form, Input} from 'antd'
import {useIntl} from 'react-intl'

const { TextArea: AntdTextArea } = Input

const TextArea = ({
  className = '',
  onChange = () => {},
  label,
  name,
  placeholder = '',
  isRequired = true,
  value = '',
  maxLength = null,
  hint = '',
  rows = 4,
  hideLabel = false,
  style=null,
  wrapperClass = '',
  errorHelp = false,
  errorMsg = '',
  readOnly = false,
  autoSize = false,
  spellCheck = false,
}) => {
  const intl = useIntl()
  return (
    <Form.Item
      name={name}
      label={label ? label : ''}
      className={`${wrapperClass} ${hideLabel ? 'hide-label' : ''}`}
      style={{ marginBottom: 0 }}
      rules={
        isRequired
          ? [
              {
                required: true,
                message:
                  errorHelp === false
                    ? ''
                    : errorMsg.length > 0
                      ? errorMsg
                      : intl.formatMessage({id: 'validation.requiredField'}, {label: label}),
              },
            ]
          : undefined
      }
      {...(errorHelp === false ? { help: '' } : {})}
      extra={hint || undefined}
    >
      <AntdTextArea
        data-testid={name}
        autoComplete="off"
        className={`custom-scroll ${className}`}
        placeholder={placeholder || label}
        value={value}
        rows={rows}
        maxLength={maxLength}
        readOnly={readOnly}
        spellCheck={spellCheck}
        {...(style ? { style } : {})}
        {...(autoSize ? { autoSize } : {})}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      />
    </Form.Item>
  )
}

TextArea.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.any,
  maxLength: PropTypes.number,
  hint: PropTypes.string,
  rows: PropTypes.number,
  hideLabel: PropTypes.bool,
  style: PropTypes.string,
  wrapperClass: PropTypes.string,
  errorHelp: PropTypes.bool,
  errorMsg: PropTypes.string,
  readOnly: PropTypes.bool,
  autoSize: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  spellCheck: PropTypes.bool,
}

export default TextArea
